import { Modal, Form, Input, Select, message } from 'antd';
import { createTicket } from 'api/tickets';

export default function TicketFormModal({ open, onClose, onCreated }) {
  const [form] = Form.useForm();

  const onOk = async () => {
    const values = await form.validateFields();
    try {
      await createTicket(values);
      message.success('Ticket creado');
      form.resetFields();
      onCreated?.();
      onClose();
    } catch (e) {
      message.error(e?.message || 'No se pudo crear el ticket');
    }
  };

  return (
    <Modal open={open} title="Nuevo ticket" onOk={onOk} onCancel={onClose} okText="Crear">
      <Form form={form} layout="vertical">
        <Form.Item
          name="descripcion"
          label="Descripción"
          rules={[
            { required: true, message: 'Describe el problema' },
            { max: 2000, message: 'Máximo 2000 caracteres' },
          ]}
        >
          <Input.TextArea rows={3} />
        </Form.Item>
        <Form.Item name="prioridad" label="Prioridad" initialValue="media">
          <Select
            options={['baja', 'media', 'alta', 'urgente'].map((p) => ({ value: p, label: p }))}
          />
        </Form.Item>
        <Form.Item name="contacto_nombre" label="Contacto (opcional)">
          <Input />
        </Form.Item>
        <Form.Item name="contacto_fono" label="Teléfono (opcional)">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
}
